import React from 'react';
import { ClaroModalCardLoader } from "@claropay/shared";
import { connect } from 'react-redux';

const ModalCardLoader = ({ isOpen, bundleIdURL }) => {
    const [loaderImage, setLoaderImage] = React.useState("");

    React.useEffect(() => {
        setLoaderImage(
            bundleIdURL && (bundleIdURL === "com.telcel.contenedor.uat" || bundleIdURL === "com.telcel.contenedor")
                ? "/images/ClaroPayLoadingBlanco2.gif"
                : "https://logos.wokko.io/ClaroPayLoading2.gif"
        )        
    },[]);

    return(
        <>
        {loaderImage &&
            <ClaroModalCardLoader
            boxShadow="none!important"
            backgroundColor="rgba(0,0,0,0.65)"
            heightLoader="150px"
            isOpen={isOpen}
            srcImage={loaderImage}
            widthLoader="150px"
        />
        }
       </> 
    )
}

const mapStateToProps = (state) => {
    const { payments } = state;

    return {
        bundleIdURL: payments.bundleId
    }
}

export default connect(mapStateToProps)(ModalCardLoader);